import { Choice } from "components/Choice";
import residencialImage from "assets/images/residencial.svg";
import loteImage from "assets/images/lote.svg";
import comercialImage from "assets/images/comercial.svg";
import { useStepperContext } from "components/Steps";

import * as S from "./styles";
import { useState } from "react";
import { DefaultFooter } from "../../../components/DefaultFooter";
import { useFormContext } from "components/Form";
import { MediaMatch } from "components/MediaMatch";
import { useHistory } from "react-router-dom";

export function PropertyTypeForm() {
  const history = useHistory();

  const { goToNextStep } = useStepperContext();
  const {
    methodsForm: { setValue, getValues },
  } = useFormContext();

  const [propertyType, setPropertyType] = useState(() => {
    const intialValue = getValues("propertyType");
    return intialValue;
  });

  function handleSetPropertyType(propertyType: string) {
    setValue("propertyType", propertyType);
    setPropertyType(propertyType);
    goToNextStep();
  }

  return (
    <S.Container>
      <S.Title>
        Conte um pouco sobre o financiamento.
        <br />
        Qual tipo de imóvel que está pensando comprar?
      </S.Title>

      <S.WrapperChoices>
        <Choice
          title="Residencial"
          size="medium"
          onClick={() => handleSetPropertyType("Residencial")}
          isSelected={propertyType === "Residencial"}
          type="button"
        >
          <img src={residencialImage} alt="Uma Casa" />
        </Choice>

        <Choice
          title="Comercial"
          size="medium"
          onClick={() => history.push("/financiamento/comercial")}
          isSelected={propertyType === "Comercial"}
          type="button"
        >
          <img src={comercialImage} alt="Uma loja" />
        </Choice>
        <Choice
          title="Lote"
          size="medium"
          onClick={() => history.push("/financiamento/lote")}
          isSelected={propertyType === "Lote"}
          type="button"
        >
          <img src={loteImage} alt="Um terreno com árvores" />
        </Choice>
      </S.WrapperChoices>

      <MediaMatch greaterThan="medium">
        <DefaultFooter />
      </MediaMatch>
    </S.Container>
  );
}
